import { tw } from '@panwds/tailwindcss';
export const selectBorderColor = ({ disabled = false, hasError = false, readOnly = false }) => {
    if (hasError) {
        return 'twds-border-red-500 dark:twds-border-red-500';
    }
    let defaultStyle = '';
    if (!(disabled || readOnly)) {
        defaultStyle =
            'hover:twds-border-gray-600 dark:hover:twds-border-gray-600 focus-within:twds-border-blue-700 dark:focus-within:twds-border-blue-400 focus-within:hover:twds-border-blue-700 dark:focus-within:hover:twds-border-blue-400';
    }
    return tw `twds-border-gray-300 dark:twds-border-gray-500/30 ${defaultStyle}`;
};
export const horizontalPadding = (size = 'md', prefix = false, suffix = false) => {
    const str = `${prefix ? 'prefix' : ''}${prefix && suffix ? '-' : ''}${suffix ? 'suffix' : ''}${!(prefix && suffix) ? `${prefix || suffix ? '-' : ''}${size}` : ''}`;
    let padding;
    switch (str) {
        case 'prefix-suffix':
            padding = 'twds-px-0';
            break;
        case 'prefix-sm':
            padding = 'twds-pr-2';
            break;
        case 'prefix-md':
            padding = 'twds-pr-4';
            break;
        case 'prefix-lg':
            padding = 'twds-pr-4';
            break;
        case 'suffix-sm':
            padding = 'twds-pl-2';
            break;
        case 'suffix-md':
            padding = 'twds-pl-4';
            break;
        case 'suffix-lg':
            padding = 'twds-pl-4';
            break;
        case 'sm':
            padding = 'twds-px-2';
            break;
        case 'md':
            padding = 'twds-px-4';
            break;
        case 'lg':
            padding = 'twds-px-4';
            break;
        default:
            padding = 'twds-px-4';
    }
    return padding;
};
//# sourceMappingURL=input.logic.js.map